"use strict";

exports.__esModule = true;
var log2 = Math.log2 ? Math.log2 : function (x) {
  return Math.log(x) / Math.LN2;
};

exports.default = log2;


//////////////////
// WEBPACK FOOTER
// ./node_modules/google-map-react/lib/utils/math/log2.js
// module id = 223
// module chunks = 0 1 2 3 4 7